<template>
  <div>chongl</div>
</template>

<script>
export default {
  name: "surfer-home",
};
</script>

<style>
</style>